<template>
  <div class="login" :style="{ backgroundImage: 'url(' + (back_logo !== '' ? back_logo : phonebg) + ')'}">
    <div class="login_box">
      <div class="login_logo_box">
        <img class="logo" :src="logo" alt="">
        <p class="title">{{ title }}</p>
      </div>
      <p class="login_title">登录</p>
      <div class="login-icon">
        <img src="../../assets/images/login/login-icon.png" alt="">
      </div>
      <van-cell-group>
        <van-field
          v-model="username"
          placeholder="请输入手机号或样本编号"
        >
          <van-icon slot="left-icon" class-prefix="iconfont" name="iconshouji" />
        </van-field>

        <van-field
          v-model="password"
          type="password"
          placeholder="请输入密码"
        >
          <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
        </van-field>

        <van-field
          v-model="captcha"
          center
          placeholder="请输入验证码"
        >
          <van-icon slot="left-icon" class-prefix="iconfont" name="iconanquan1" />
          <img slot="right-icon" :src="imgUrl" alt="code" class="icon-code" @click="changeCode">
        </van-field>
      </van-cell-group>
      <div class="forgetpwd" v-if="status === 'yes'" @click="$router.push({path: '/forgetPwd'})">忘记密码?</div>
      <div class="btn-login" @click="goLogin()">马上登录</div>
    </div>
    <div class="footer">© 2014-{{year}} Genekang. All Rights Reserved <a style="color:#fff" href="https://beian.miit.gov.cn/" target="_blank">京ICP备14047766号-1</a></div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'index',
  data () {
    return {
      year: new Date().getFullYear(),
      username: '', // 手机号
      password: '', // 密码
      captcha: '', // 验证码
      key: '', // 验证码校验key
      // imgUrl: this.api.captcha1,
      imgUrl: '',
      start: 0,
      phonebg: require('@/assets/images/login/login-bg.png'), // 默认背景
      logo: require('@/assets/images/login/login-logo.png'), // 默认logo
      title: '基因健康应用中心',
      back_logo: '',
      domain: 'genekang.genekang.com',
      status: ''
    }
  },
  methods: {
    // 检查是否有重置密码功能接口
    checkFeature () {
      this.util.get(this.api.checkFeature, '', (success) => {
        this.status = success.status
      })
    },
    getLogo () {
      this.util.get(this.api.getlogo, '', (success) => {
        this.logo = 'https://' + success.domain + success.logo
        this.title = success.custom_name
        this.domain = success.domain
        this.back_logo = 'https://' + this.domain + success.back_logo
      })
    },
    changeCode () {
      this.util.get(this.api.captcha, '', (success) => {
        this.imgUrl = success.img
        this.key = success.key
      }, (error) => {
        Toast(error)
      })
      // let imgUrl = this.imgUrl.split('?')[0]
      // let num = this.start++
      // this.imgUrl = imgUrl + '?' + num
    },
    goLogin () {
      let data = new FormData()
      data.append('username', this.username)
      data.append('password', this.password)
      data.append('captcha', this.captcha)
      data.append('key', this.key)
          this.util.post(this.api.login, data, (success) => {
          for (let i in success.access_token) {
            this.util.setLS(this.api.access_token, success.access_token[i])
          }
          this.util.setLS('access_token', success.access_token)
          this.util.setLS(this.api.username, this.username)
          this.util.setLS(this.api.uid, success.uid)
          // status(1为gadb3，0为gadb2)
          this.util.setLS(this.api.status, success.status)
          // 20231204 新增小产品开发   
          this.util.setLS('headerSign', JSON.stringify({
            header:success.header,
            sign:success.sign,
            // header:'um7s388t5upcs7q',
            // sign:'x1c21xu4a2xz2m3qujdwfxo2n',
          }))


          if (success.loginType === 'phone') {
            this.$router.push('/multiomics')
          } else {
            this.$router.push('/home')
          }
        // this.util.setLS(this.api.status, 1)
        // if (this.util.getLS(this.api.status) === 1) {
        //   this.$router.push('/home')
        // } else {
        //   Toast('维护调试中，敬请期待')
        // }
        }, (error) => {
          this.changeCode()
          Toast(error)
        })
      }
    // gdb2
    /* goLogin1 () {
      let data = {
        phone: this.username,
        pwd: this.password,
        code: this.captcha
      }
      this.util.post(this.api.login1, data, (success) => {
        this.util.setLS(this.api.access_token, success.auth_key)
        this.util.setLS(this.api.username, this.username)
        // status(gdb2)
        this.util.setLS(this.api.status, success.status)
        this.$router.push('/home')
      }, (error) => {
        this.changeCode()
        Toast(error)
      })
    } */
  },
  beforeCreate(){
    if(window.location.origin === 'https://zydemo.genekang.com'){
              this.util.get(this.api.childwes_zy_demo, '', (success) => {
              this.$router.push('/exhibition')
              for (let i in success.access_token) {
                  this.util.setLS(this.api.access_token, success.access_token[i])
              } 
              this.util.setLS('access_token', success.access_token)
              this.util.setLS(this.api.uid, success.uid)
            })
      }
  },
  mounted () {
    console.log(window.location.host)
    let token = this.$route.query.token
    let lastUserName = this.util.getLS(this.api.username)
    this.changeCode()
    this.getLogo()
    this.checkFeature()
    if (token) {
      this.util.setLS(this.api.access_token, token)
      this.$router.push('/home')
    } else if (lastUserName) {
      this.username = lastUserName
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/functions";
.login {
  width: 100%;
  height: 100%;
  /*background: url("../../assets/images/login/login-bg.png");*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .login_box {
    width: pxToRem(500px);
    min-height: pxToRem(1000px);
    // position: absolute;
    /*top: 50%;*/
    // top: 8%;
    // left: 50%;
    /*margin-top: pxToRem(-500px);*/
    margin-left: pxToRem(-250px);
    margin: 8%  auto;

    .login_logo_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: pxToRem(100px);

      .logo {
        width: pxToRem(90px);
        margin-right: pxToRem(30px);
      }

      .title {
        color: #fff;
        font-size: pxToRem(35px);
        letter-spacing: 2px;
        font-weight: 500;
      }
    }

    .login_title {
      text-align: center;
      font-size: pxToRem(45px);
      letter-spacing: 1px;
      color: #fff;
      margin-bottom: pxToRem(30px);
      font-weight: 500;
    }

    .login-icon {
      text-align: center;
      margin-bottom: pxToRem(40px);

      img {
        width: pxToRem(48px);
      }
    }

    .icon-code {
      width: 0.67rem;
    }

    .btn-login {
      width: 100%;
      padding: pxToRem(15px) pxToRem(20px);
      background:linear-gradient(-90deg,rgba(31,112,163,1),rgba(31,88,146,1));
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
      border-radius: pxToRem(50px);
      text-align: center;
      color: #fff;
      letter-spacing: 2px;
      font-size: pxToRem(30px);
      font-weight: 500;
    }

    .van-cell-group, .van-cell, .van-field__control {
      background-color: transparent;
      color: #fff;
    }

    .van-field__control::-webkit-input-placeholder {
      color: #fff;
      font-size: pxToRem(20px);
    }

    .iconfont {
      font-size: pxToRem(50px);
      vertical-align: middle;
    }

    .van-cell {
      background:rgba(0, 0, 0, 0.3);
      margin-bottom: pxToRem(60px);
      border: pxToRem(1px) solid rgba(255, 255, 255, 1);
      border-radius: pxToRem(50px);
      padding: pxToRem(10px) pxToRem(20px);
      line-height: inherit;
    }
    .van-cell:last-of-type {
      margin-bottom: pxToRem(30px);
    }
    .forgetpwd {
      margin-left: pxToRem(30px);
      margin-bottom: pxToRem(20px);
      color: #fff;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: 0;
    }
  }
}
  .footer{
    color: #fff;
    margin: 1rem auto 10px;
    text-align: center;
    // margin-top: 6rem;
    // position: absolute;
    // bottom: 10px;
    // left: 50%;
    // transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue